import { api } from "./api";
import jwtDecode from "jwt-decode";

const CHAVE_USUARIO = "@usuario";

export const signIn = (usuario) => {
  localStorage.setItem(CHAVE_USUARIO, JSON.stringify(usuario));

  api.defaults.headers.common["Authorization"] = `Bearer ${usuario.token}`;
};

export const signOut = () => {
  localStorage.clear();

  api.defaults.headers.common["Authorization"] = undefined;
};

export const getUsuario = () => {
  const usuarioLocal = JSON.parse(localStorage.getItem(CHAVE_USUARIO));
  if (!usuarioLocal) return false;
  const { usuario } = usuarioLocal;

  return usuario;
};

export const getToken = () => {
  const usuarioLocal = JSON.parse(localStorage.getItem(CHAVE_USUARIO));
  if (!usuarioLocal) return false;
  const { token } = usuarioLocal;

  return token;
};

export const setUsuario = (usuario) => {
  let userStorage = JSON.parse(localStorage.getItem(CHAVE_USUARIO));

  userStorage.usuario = usuario;

  localStorage.setItem(CHAVE_USUARIO, JSON.stringify(userStorage));
};

export const isSignedIn = (perfil) => {
  const usuario = JSON.parse(localStorage.getItem(CHAVE_USUARIO));
  if (usuario && usuario.token) {
    var jwtDecoded = jwtDecode(usuario.token);
    const nowSec = (Date.now() / 1000) | 0;
    if (jwtDecoded.perfil !== perfil || nowSec > jwtDecoded.exp) {
      return signOut();
    }
    api.defaults.headers.common["Authorization"] = `Bearer ${usuario.token}`;
    return true;
  }
};
